module.exports = __webpack_public_path__ + "media/images/bg-footer-db56bb9e1f92dad2dc86a6a51aa8649c.jpg";